import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChannelsChatRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-channels-chat',
	path: '/jira/servicedesk/projects/:projectKey/settings/channels/chat',
	exact: true,
};
